<template>
  <b-card no-body>

    <div class="card-header d-flex justify-content-between align-items-center">
      <div>
        <b-card-title>Évaluation</b-card-title>
      </div>
      <b-form-select
          id="yearSelect"
          v-model="currentYear"
          size="sm"
          :options="yearOptions"
          class="budget-dropdown"
      />
    </div>

    <b-card-body>
      <b-row>
        <b-col
            sm="6"
            order-sm="1"
            order="2"
            class="d-flex justify-content-between flex-column mt-1 mt-sm-0"
        >
          <div>
          <h1 class="font-large-2 font-weight-bolder mt-2 mb-0">
            {{ dataEvaluation.totalToDo }}
          </h1>
          <small>Total à faire</small>
          </div>


          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="shadow"
              @click="$router.push({
                  name: 'user-stay-doing-evaluation',
                  params: { year }
                })"
          >
            <span>Reste à faire </span>
            <feather-icon icon="ChevronsRightIcon" />
          </b-button>
        </b-col>

        <!-- chart -->
        <b-col
            sm="6"
            cols="12"
            order-sm="2"
            order="1"
            class="d-flex justify-content-between flex-column text-right"
        >

          <!-- apex chart -->
          <vue-apex-charts
              type="radialBar"
              height="270"
              :options="supportTrackerRadialBar.chartOptions"
              :series="dataEvaluation.validated"
          />
        </b-col>
        <!--/ chart -->
      </b-row>
      <hr>

      <b-row class="avg-sessions pt-50">
        <b-col cols="6" class="mb-2">
          <b-card-text class="mb-50">
            Auto-évaluation: {{ dataEvaluation.selfAssessment }}
          </b-card-text>
          <b-progress
              :value="dataEvaluation.selfAssessment"
              :max="dataEvaluation.totalToDo"
              height="6px"
              variant="primary"
          />
        </b-col>
        <b-col cols="6" class="mb-2">
          <b-card-text class="mb-50">
            Évaluation: {{ dataEvaluation.preAssessment }}
          </b-card-text>
          <b-progress
              :value="dataEvaluation.preAssessment"
              :max="dataEvaluation.totalToDo"
              height="6px"
              variant="info"
          />
        </b-col>
        <b-col cols="6" class="mb-2">
          <b-card-text class="mb-50">
            Évaluation : {{ dataEvaluation.assessment }}
          </b-card-text>
          <b-progress
              :value="dataEvaluation.assessment"
              :max="dataEvaluation.totalToDo"
              height="6px"
              variant="success"
          />
        </b-col>

        <b-col cols="6" class="mb-2">
          <b-card-text class="mb-50">
            Transféré au N+2: {{ dataEvaluation.transferred }}
          </b-card-text>
          <b-progress
              :value="dataEvaluation.transferred"
              :max="dataEvaluation.totalToDo"
              height="6px"
              variant="warning"
              class="mt-25"
          />
        </b-col>
        <b-col cols="6" class="mb-2">
          <b-card-text class="mb-50">
            Rejeté par N+2: {{ dataEvaluation.rejected }}
          </b-card-text>
          <b-progress
              :value="dataEvaluation.rejected"
              :max="dataEvaluation.totalToDo"
              height="6px"
              variant="danger"
              class="mt-25"
          />
        </b-col>
      </b-row>

    </b-card-body>

  </b-card>
</template>

<script>
import {
  BCard, BProgress, BCardTitle, BCardBody, BRow, BCol, BCardText, BFormSelect, BButton,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import {getCountByStatusAndYearsByEvaluation} from "@/services/UserEvaluationService";
import { getSetting } from "@/services/SettingService";
import { allYears } from "@/services/YearsService";
import Ripple from 'vue-ripple-directive';

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BFormSelect,
    VueApexCharts,
    BCard,
    BProgress,
    BCardTitle,
    BCardText,
    BCardBody,
    BRow,
    BCol,
  },

  data() {
    return {
      supportTrackerRadialBar: {
        chartOptions: {
          plotOptions: {
            radialBar: {
              size: 150,
              offsetY: 20,
              startAngle: -150,
              endAngle: 150,
              hollow: { size: '65%' },
              track: { background: '#fff', strokeWidth: '100%' },
              dataLabels: {
                name: { offsetY: -5, color: '#5e5873', fontSize: '1rem' },
                value: { offsetY: 15, color: '#5e5873', fontSize: '1.714rem' },
              },
            },
          },
          colors: [$themeColors.danger],
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              type: 'horizontal',
              shadeIntensity: 0.5,
              gradientToColors: [$themeColors.primary],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: { dashArray: 8 },
          labels: ['Évaluation validée'],
        },
      },
      dataEvaluation: {},
      currentYear: null,
      years: [],
      year:null,

    }
  },

  computed: {
    yearOptions() {
      return this.years.map(year => ({ value: year.year, text: `${year.year}` }));
    },
  },

  watch: {
    currentYear(newYear) {
      if (newYear) {
        this.getCountByStatusAndYearsByEvaluation(newYear);
      }
    },
  },

  methods: {
    async getCountByStatusAndYearsByEvaluation(year) {
      const y = year || this.currentYear;
      if (!y) return;

      try {
        this.year = y;

        this.dataEvaluation = await getCountByStatusAndYearsByEvaluation(y);
      } catch (error) {
        console.error('Erreur API Evaluation:', error.response ? error.response.data : error);
      }
    },

    async getAllYears() {
      try {
        this.years = await allYears();
        if (!this.currentYear && this.years.length) {
          this.currentYear = this.years[0].year;
          await this.getCountByStatusAndYearsByEvaluation();
        }
      } catch (error) {
        console.error('Erreur récupération années:', error);
      }
    },

    async settings() {
      try {
        const response = await getSetting();
        if (response && response.yearEvaluation) {
          this.currentYear = response.yearEvaluation?.year;
          await this.getCountByStatusAndYearsByEvaluation();
        }
      } catch (error) {
        console.error('Erreur récupération settings:', error);
        if (!this.currentYear && this.years.length) {
          this.currentYear = this.years[0].year;
          await this.getCountByStatusAndYearsByEvaluation();
        }
      }
    },
  },

  mounted() {
    this.getAllYears();
    this.settings();
  }
}
</script>


<style scoped>
.budget-dropdown {
  width: 80px;
  border: 1px solid #005cb9;
  border-radius: 0.357rem;
  background-color: #fff;
  font-size: 1rem;
  line-height: 1.45;
  color: #005cb9;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.budget-dropdown:focus,
.budget-dropdown:active {
  border-color: #7367f0;
  box-shadow: 0 0 0 0.2rem rgba(115, 103, 240, 0.2);
  outline: none;
}
</style>